<template lang='pug'>
div(
  v-if='ready'
)
  slot
</template>

<script>
import { initFatsecretApi } from '../functions/initFatsecretApi';

async function mounted()
{
  this.$emit('start');

  await initFatsecretApi();

  this.$emit('stop');

  this.ready = true;
}

export default
{
  data()
  {
    return {
      ready: false
    };
  },
  mounted,
};
</script>